// Configuration SEO par route. Chaque entrée définit:
//  - title: balise <title>
//  - description: meta description
//  - scrollTo: id de la section vers laquelle scroller au mount
//  - h1Override: (optionnel) H1 personnalisé pour cette URL (sinon défaut Hero)
// Les routes marketing rendent toutes le composant <Home /> mais avec
// un contenu SEO contextualisé pour Google.

export const SEO_ROUTES = {
  home: {
    path: "/",
    title:
      "GMC Rénovation Façade | Ravalement et Enduit Façade à Valenciennes",
    description:
      "Spécialiste du ravalement de façade à Valenciennes. Enduit projeté, imitation pierre, rejointoiement de briques, nettoyage façade et rénovation extérieure. Devis gratuit.",
    scrollTo: null,
  },
  configurateur: {
    path: "/configurateur",
    title: "Configurateur Façade IA — Visualisez votre façade | GMC Valenciennes",
    description:
      "Uploadez une photo de votre façade et visualisez 5 propositions de rénovation générées par IA : enduit, pierre de taille, LED, imitation brique. Gratuit et instantané.",
    scrollTo: "configurateur",
  },
  estimation: {
    path: "/estimation",
    title:
      "Devis Gratuit à Domicile — Prix ravalement Valenciennes | GMC Rénovation",
    description:
      "Réservez la visite gratuite d'un expert GMC à votre domicile pour un devis précis et sans engagement : ravalement, enduit projeté, rejointoiement, imitation pierre, ITE.",
    scrollTo: "rdv-devis",
  },
  realisations: {
    path: "/realisations",
    title:
      "Réalisations Façade — Avant/Après | GMC Rénovation Façade Valenciennes",
    description:
      "Découvrez nos chantiers de ravalement de façade dans le Nord (59) : avant/après, enduit gratté, rejointoiement de briques, imitation pierre de taille, ITE.",
    scrollTo: "realisations",
  },
  avis: {
    path: "/avis",
    title:
      "Avis clients GMC Rénovation Façade — Note 5/5 Valenciennes",
    description:
      "Les avis vérifiés des clients de GMC Rénovation Façade à Valenciennes. Note moyenne 5/5 sur Google, 25+ ans d'expérience, garantie décennale.",
    scrollTo: "avis",
  },
  diagnostic: {
    path: "/diagnostic-facade",
    title:
      "Diagnostic Façade Gratuit par IA | GMC Rénovation Façade Nord 59",
    description:
      "Analyse automatique de l'état de votre façade par intelligence artificielle. Diagnostic gratuit, estimation des travaux et plus-value immobilière en 30 secondes.",
    scrollTo: "diagnostic",
  },
  isolationThermique: {
    path: "/isolation-thermique",
    title:
      "Isolation Thermique Extérieure (ITE) Valenciennes | GMC Rénovation Façade",
    description:
      "Spécialiste de l'isolation thermique par l'extérieur (ITE) à Valenciennes et dans le Nord (59). Jusqu'à 25 % d'économies de chauffage, éligible MaPrimeRénov'. Devis gratuit.",
    scrollTo: "rdv-devis",
  },
  devis: {
    path: "/devis",
    title:
      "Devis Gratuit Façade Valenciennes | GMC Rénovation Façade Nord 59",
    description:
      "Demandez votre devis gratuit de ravalement, enduit projeté, rejointoiement ou isolation thermique extérieure. Réponse sous 24h, intervention dans tout le Nord (59).",
    scrollTo: "contact",
  },
  faq: {
    path: "/faq",
    title:
      "FAQ Ravalement Façade — Prix, délais, aides 2026 | GMC Valenciennes",
    description:
      "Réponses à vos questions sur le ravalement de façade : prix au m², délais, garantie décennale, aides MaPrimeRénov', rejointoiement de briques, zones d'intervention.",
    scrollTo: "faq",
  },
  zones: {
    path: "/zones-intervention",
    title:
      "Zones d'intervention — Façade Valenciennes, Anzin, Denain | GMC Nord 59",
    description:
      "GMC Rénovation Façade intervient dans tout le département du Nord (59) : Valenciennes, Anzin, Saint-Saulve, Marly, Denain, Bruay-sur-l'Escaut, Maubeuge et plus.",
    scrollTo: "zones",
  },
  contact: {
    path: "/contact",
    title: "Contact GMC Rénovation Façade — Devis gratuit Valenciennes",
    description:
      "Demandez votre devis gratuit de rénovation de façade. Téléphone 07 63 43 38 67 ou formulaire en ligne. Réponse sous 24h, intervention dans tout le Nord (59).",
    scrollTo: "contact",
  },
};

// Routes effectivement pré-rendues par le script SSG (toutes sauf l'admin).
export const PRERENDER_PATHS = Object.values(SEO_ROUTES).map((r) => r.path);
